export default __webpack_public_path__ + "8c3d5a90eef97a6f65a2267453ab85ad.ttf";